import { Close } from '@mui/icons-material'
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
} from '@mui/material'
import I18n from 'i18n-js'
import queryString from 'query-string'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  gridContainer: {
    textAlign: 'center',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  divider: {
    marginBottom: 10,
  },
}))

function LoginDialog(props) {
  const { classes } = useStyles()
  let currentUrl = decodeURIComponent(window.location.href)
  if (currentUrl.indexOf('?') === -1) {
    currentUrl = `${currentUrl}?showDialog=true`
  } else {
    currentUrl = `${currentUrl}&showDialog=true`
  }

  // pass user_confirmation token if available to to avoid duplicate confirmation requests
  const { user_confirmation_token } = queryString.parse(window.location.search)
  const emailConfirmParam = user_confirmation_token
    ? queryString.stringify({ user_confirmation_token })
    : ''
  return (
    <Dialog
      aria-labelledby="simple-dialog-title"
      onClose={props.closeDialog}
      open={props.open}
    >
      <IconButton
        aria-label="close"
        className={classes.closeButton}
        onClick={props.closeDialog}
        size="large"
      >
        <Close />
      </IconButton>
      <DialogTitle>{I18n.t('auth.registerOrLogin')}</DialogTitle>
      <Divider className={classes.divider} />
      <DialogContent>
        <Grid className={classes.gridContainer} container spacing={3}>
          <Grid item xs={5}>
            {I18n.t('auth.newToPromoboxxQuestionMark')}
          </Grid>
          <Grid item xs />
          <Grid item xs={5}>
            {I18n.t('auth.alreadyHaveAPromoboxxAccountQuestionMark')}
          </Grid>
        </Grid>
        <Grid className={classes.gridContainer} container spacing={3}>
          <Grid item xs={5}>
            <Button
              className={classes.registerButton}
              color="secondary"
              href={`/#/register/${props.brandSlug}/${props.registrationKey}/user?${emailConfirmParam}`}
              size="large"
              variant="contained"
              data-testid={'registerOrLoginDialogRegisterButton'}
            >
              {I18n.t('auth.register')}
            </Button>
          </Grid>
          <Grid item xs>
            OR
          </Grid>
          <Grid item xs={5}>
            <Button
              className={classes.loginButton}
              color="primary"
              href={`/login?redirect_url=${window.encodeURIComponent(
                currentUrl,
              )}`}
              size="large"
              variant="contained"
              data-testid={'registerOrLoginDialogLoginButton'}
            >
              {I18n.t('auth.login')}
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default LoginDialog
